import _defineProperty from "/vercel/workpath0/.yarn/cache/@babel-runtime-npm-7.12.5-b3edb8ee8e-423fb00793.zip/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/workpath0/.yarn/cache/@babel-runtime-npm-7.12.5-b3edb8ee8e-423fb00793.zip/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/vercel/workpath0/.yarn/cache/@babel-runtime-npm-7.12.5-b3edb8ee8e-423fb00793.zip/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  * { box-sizing: border-box; }\n  body { margin: 0; }\n  table { border-collapse: collapse; }\n  body.intent-mouse {\n    [role=\"button\"]:focus,\n    [role=\"tabpanel\"][tabindex=\"0\"]:focus,\n    button:focus,\n    summary:focus,\n    a:focus {\n      outline: none;\n      box-shadow: none;\n    }\n\n    [tabindex=\"0\"]:focus,\n    details-dialog:focus {\n      outline: none;\n    }\n  }\n\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import PropTypes from 'prop-types';
import { TYPOGRAPHY, COMMON } from './constants';
import useMouseIntent from './hooks/useMouseIntent';
import theme from './theme';
var GlobalStyle = createGlobalStyle(_templateObject());

var Base = function Base(props) {
  var color = props.color,
      lineHeight = props.lineHeight,
      fontFamily = props.fontFamily,
      theme = props.theme,
      rest = _objectWithoutProperties(props, ["color", "lineHeight", "fontFamily", "theme"]);

  useMouseIntent();
  return /*#__PURE__*/React.createElement("div", rest, /*#__PURE__*/React.createElement(GlobalStyle, null), props.children);
};

Base.displayName = "Base";
var BaseStyles = styled(Base).withConfig({
  displayName: "BaseStyles",
  componentId: "sc-8q0tj8-0"
})(["", " ", ";"], TYPOGRAPHY, COMMON);
BaseStyles.defaultProps = {
  color: 'gray.9',
  fontFamily: 'normal',
  lineHeight: 'default',
  theme: theme
};
BaseStyles.propTypes = _objectSpread(_objectSpread(_objectSpread({}, TYPOGRAPHY.propTypes), COMMON.propTypes), {}, {
  theme: PropTypes.object
});
export default BaseStyles;